import React, { createContext, useContext, useState } from "react";

const ScreenerContext = createContext();

export const useScreener = () => {
  const context = useContext(ScreenerContext);
  if (!context) {
    throw new Error("useScreener must be used within a ScreenerProvider");
  }
  return context;
};

export const ScreenerProvider = ({ children }) => {
  const [shouldSortByRecent, setShouldSortByRecent] = useState(false);
  const [highlightTop3, setHighlightTop3] = useState(false);

  const triggerRecentSort = () => {
    setShouldSortByRecent(true);
    setHighlightTop3(true);

    // Reset after component has processed the request
    setTimeout(() => {
      setShouldSortByRecent(false);
    }, 100);

    // Remove highlight after 5 seconds
    setTimeout(() => {
      setHighlightTop3(false);
    }, 5000);
  };

  return (
    <ScreenerContext.Provider
      value={{
        shouldSortByRecent,
        highlightTop3,
        triggerRecentSort,
      }}
    >
      {children}
    </ScreenerContext.Provider>
  );
};
